import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';

import { isFedRamp } from '@atlaskit/atlassian-context/is-fedramp';
import { DefaultExtensionProvider } from '@atlaskit/editor-common/extensions';
import { fg } from '@atlaskit/platform-feature-flags/fg';

import buildActionItemsPanelManifest from './manifests/action-items/manifest';
import buildSummarisePagePanelManifest from './manifests/summarise-page/manifest';
import type { AIManifest } from './types';

export const getAIPanelsProvider = ({
	intl,
	providerFactory,
}: AIManifest): // eslint-disable-next-line @typescript-eslint/no-explicit-any
DefaultExtensionProvider<any> => {
	const summarisePage = buildSummarisePagePanelManifest({
		intl,
		providerFactory,
	});
	const findActionItems = buildActionItemsPanelManifest({
		intl,
		providerFactory,
	});
	const extensions = [];

	/**
	 * WARNING: Do not remove the isFedRamp check.
	 * This is to ensure that AI functionality is not enabled in FedRamp environments.
	 */
	const isEnabled = fg('use_frontend_feature_encoding_sdk_platform')
		? isFeatureEnabled('rovo', 'rovo-editor-ai-panels')
		: !isFedRamp();

	if (isEnabled) {
		extensions.push(summarisePage);
		extensions.push(findActionItems);
	}

	// Ignored via go/ees005
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	return new DefaultExtensionProvider<any>(extensions);
};
